import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6592d260&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6592d260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592d260",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeClipfly: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/home-clipfly.vue').default,HomeFotor2: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/home-fotor2.vue').default})
